<template>
    <div class="selected-numbers-container">
        <div class="month-count-container">
            <h2 class="selected-numbers-main_title">
                {{ $t("page.tariffs.amount_months") }}
            </h2>
            <count-month
                :countMonth="selectedNumbers.count.months"
                @onMonthsButton="chooseCountMonths"
            />
        </div>

        <div class="title-container">
            <h2 class="selected-numbers-title">
                {{ $t("page.tariffs.choose_numbers") }}
                {{ $t("page.tariffs.for_payment") }}:
            </h2>
        </div>

        <div
            v-for="msg in Object.values(messengers)"
            :key="msg.value"
            :class="`selected-numbers-${msg.value}`"
        >
            <HeaderTableBlock
                :title="$t('common.numbers')"
                :countTitle="paginationAllMsgrs[msg.value][0]?.total"
                :messenger="msg.value"
                :loading="!!tableState[msg.value]?.isLoading"
                :sendInput="tableState[msg.value]?.search"
                @submitInput="getNumberDataBySearchValue($event, msg.value)"
            />

            <!--     TAGS ITEMS       -->
            <NumberTagsList
                v-if="preselectedNumbers[msg.value]?.length"
                :numbers="preselectedNumbers[msg.value]"
                :msg="msg.value"
                @unselect-all="unselectAllByMsg(msg.value)"
                @simple-unselect="(n) => unselectSimpleByMsg(msg.value, n)"
            />

            <div class="selected-numbers-table">
                <component
                    :is="widthWindow.value > 1200 ? 'TableNumbersTariffs' : 'MobileTableRecurring'"
                    :rowData="tableState[msg.value]?.data"
                    :msg="msg"
                    :Numbers="tableState[msg.value]?.data"
                    :messenger="msg"
                    :tableType="'selected'"
                    :check-if-selected="isSelectedNumber"
                    @toggleSelectionHandler="toggleSelection"
                    @loadMore="loadMore(msg.value)"
                >
                    <!-- INFORMATION BLOCK -->
                    <template #information_column>
                        <InfoDataTextRecurring
                            v-show="tableState[msg.value]?.statusState"
                            :value="tableState[msg.value]?.statusState"
                            height="120px"
                        />
                    </template>
                    <!-- PAGINATION IN SMALL AND MEDIUM SCREENS -->
                    <template #pagination>
                        <BasePagination
                            :lastPage="paginationAllMsgrs[msg.value][0]?.last_page"
                            :currentPage="paginationAllMsgrs[msg.value][0]?.current_page"
                            @onChangePage="(numberPage) => changePage(numberPage, msg.value)"
                        />
                    </template>
                </component>
            </div>
        </div>
    </div>
</template>
<script>
import MobileTableRecurring from "../Recurring/MobileTableRecurring.vue";
import CountMonth from "../Recurring/CountMonth.vue";
import InfoDataTextRecurring from "@/components/Recurring/InfoDataTextRecurring.vue";
import messengers from "@/data/messengers";
import {mapState, mapActions, mapMutations} from "vuex";
import TableNumbersTariffs from "./TableNumbersTariffs.vue";
import {useWindowSize} from "@vueuse/core";
import BasePagination from "@/components/ui/BasePagination.vue";
import HeaderTableBlock from "@/components/ui/table/HeaderTableBlock.vue";
import NumberTagsList from "@/components/Tariffs/NumberTagsList.vue";

export default {
    components: {
        NumberTagsList,
        CountMonth,
        MobileTableRecurring,
        InfoDataTextRecurring,
        TableNumbersTariffs,
        BasePagination,
        HeaderTableBlock,
    },
    data() {
        return {
            windowSize: 0,
            messengers,
            searchViberQuery: "",
            searchTelegramQuery: "",
            selectedNumbers: {
                count: {
                    months: this.updatedData.count.months || 1,
                    viber: this.updatedData.count.viber,
                    telegram: this.updatedData.count.telegram,
                    whatsapp: this.updatedData.count.whatsapp,
                },
                viber: this.updatedData.viber || [],
                telegram: this.updatedData.telegram || [],
                whatsapp: this.updatedData.whatsapp || [],
            },
        };
    },
    props: {
        updatedData: {
            type: Object,
        },
        number: {
            type: String,
            default: "",
        },
    },

    emits: ["calculatePayloadUpdated", "changedTableData"],
    computed: {
        ...mapState({
            numbersViber: (state) => state.numbers.numbersDataViber[0],
            numbersTelegram: (state) => state.numbers.numbersDataTelegram[0],
            numbersWhatsapp: (state) => state.numbers.numbersDataWhatsapp[0],

            numbersViberLoading: (state) => state.numbers.numbersDataAttributes.loading.viber[0],
            numbersTelegramLoading: (state) => state.numbers.numbersDataAttributes.loading.telegram[0],
            numbersWhatsappLoading: (state) => state.numbers.numbersDataAttributes.loading.whatsapp[0],

            numbersViberSearch: (state) => state.numbers.numbersDataAttributes.searchInput.viber[0],
            numbersTelegramSearch: (state) => state.numbers.numbersDataAttributes.searchInput.telegram[0],
            numbersWhatsappSearch: (state) => state.numbers.numbersDataAttributes.searchInput.whatsapp[0],

            paginationAllMsgrs: (state) => state.numbers.numbersDataAttributes?.numberListPagination,
            preselectedNumbers: (state) => state.numbers.preselectedNumbers,
        }),

        widthWindow() {
            const {width} = useWindowSize();
            return width;
        },

        tableState() {
            return {
                viber: {
                    data: this.numbersViber,
                    isLoading: this.numbersViberLoading,
                    search: this.numbersViberSearch,
                    statusState: this.numbersViberLoading ? 'loading' : !this.numbersViber?.length ? 'noNumbers' : null
                },
                telegram: {
                    data: this.numbersTelegram,
                    isLoading: this.numbersTelegramLoading,
                    search: this.numbersTelegramSearch,
                    statusState: this.numbersTelegramLoading ? 'loading' : !this.numbersTelegram?.length ? 'noNumbers' : null
                },
                whatsapp: {
                    data: this.numbersWhatsapp,
                    isLoading: this.numbersWhatsappLoading,
                    search: this.numbersWhatsappSearch,
                    statusState: this.numbersWhatsappLoading ? 'loading' : !this.numbersWhatsapp?.length ? 'noNumbers' : null
                }
            };
        }
    },
    methods: {
        ...mapActions("numbers", ["loadConnectedNumbers"]),
        ...mapMutations("numbers", ["SET_PRESELECTED_NUMBERS_BY_MSG"]),

        onResize() {
            this.windowSize = window.innerWidth;
        },

        generateSelectedNumbers(numbers, msg) {
            if (!msg) return;

            this.selectedNumbers = {
                ...this.selectedNumbers,
                [msg]: [...numbers],
            };
        },


        isSelectedNumber(number, messenger) {
            if (!number || !messenger) return;

            return this.preselectedNumbers[messenger]?.some(v => v.number === number);
        },

        toggleSelection(item, messenger) {
            const list = this.preselectedNumbers[messenger];
            const isExist = this.isSelectedNumber(item.number, messenger);
            const updatedArray =
                !isExist
                    ? [...list, item]
                    : list.filter(v => v.number !== item.number);

            this.$store.commit("numbers/SET_PRESELECTED_NUMBERS_BY_MSG", {data: updatedArray, msg: messenger});

            this.generateSelectedNumbers(updatedArray, messenger);
            this.$emit("calculatePayloadUpdated", this.selectedNumbers);
        },

        chooseCountMonths(number) {
            this.selectedNumbers.count.months = number;
            this.$emit("calculatePayloadUpdated", this.selectedNumbers);
        },

        // TODO: refactor to async fn
        bounceCheckedHeight() {
            setTimeout(() => {
                this.$emit("changedTableData");
            }, 0);
        },

        async loadNumbersData() {
            const promises = [
                this.$store.dispatch("numbers/loadNumbersByMessenger", {
                    messenger: "viber",
                    visibility: true,
                }),
                this.$store.dispatch("numbers/loadNumbersByMessenger", {
                    messenger: "telegram",
                    visibility: true,
                }),
                this.$store.dispatch("numbers/loadNumbersByMessenger", {
                    messenger: "whatsapp",
                    visibility: true,
                }),
            ];

            await Promise.allSettled(promises);
        },

        loadMore(messenger) {
            const visibility = true;
            const number = this.$store.state.numbers.numbersDataAttributes.searchInput[messenger][0] || null;

            const pageData = this.paginationAllMsgrs[messenger][0];
            const isLastPage = pageData.current_page === pageData.last_page;
            const page = !isLastPage && pageData.current_page + 1;

            if (!isLastPage) {
                this.$store.dispatch("numbers/loadNumbersByMessenger", {
                    messenger,
                    number,
                    page,
                    visibility,
                });
            }
        },

        changePage(numberPage, messenger) {
            const visibility = true;
            const number = this.$store.state.numbers.numbersDataAttributes.searchInput[messenger][0] || null;

            this.$store.dispatch("numbers/loadNumbersByMessenger", {
                messenger,
                number,
                page: numberPage,
                visibility,
                isCollectData: false,
            });
        },

        getNumberDataBySearchValue(input, messenger) {
            const visibility = true;

            this.$store.dispatch("numbers/setSearchInput", {input, messenger, visibility});

            this.$store.dispatch("numbers/loadNumbersByMessenger", {
                number: input,
                messenger,
                visibility,
            });
        },

        unselectAllByMsg(messenger) {
            this.selectedNumbers[messenger] = [];
            this.updatePreselectedNumbers([], messenger);
        },

        unselectSimpleByMsg(messenger, number) {
            const list = this.preselectedNumbers[messenger];
            const filtered = list.filter(v => v.number !== number);
            this.updatePreselectedNumbers(filtered, messenger);
        },


        updatePreselectedNumbers(list, messenger) {
            this.$store.commit("numbers/SET_PRESELECTED_NUMBERS_BY_MSG", {
                data: list,
                msg: messenger
            });

            this.generateSelectedNumbers(list, messenger);
            this.$emit("calculatePayloadUpdated", this.selectedNumbers);
        },


    },
    mounted() {
        // при монтировании страницы загружаем данные, если авторизован
        // TODO: при выходе из аккаунта монтирует компонент и стучиться на бэкенд(не авторизованным)
        console.debug(this.$store.getters["auth/isLoggedIn"]);

        this.$store.getters["auth/isLoggedIn"] && this.loadNumbersData();
    },
    unmounted() {
        this.unselectAllByMsg('viber');
        this.unselectAllByMsg('telegram');
        this.unselectAllByMsg('whatsapp');
    },
    created() {
        window.addEventListener("resize", this.onResize);
        this.onResize();
    },
};
</script>
<style scoped lang="scss">
.rotate {
    transform: rotate(180deg);
}

.arrow-down {
    transition: transform 0.5s ease;
}

.custom-checkbox input[type="checkbox"] {
    display: none;
}

.custom-checkbox label {
    display: inline-block;
    width: 25px;
    height: 25px;
    border: 1px solid lightgrey;
    cursor: pointer;
    position: relative;
}

.custom-checkbox label::after {
    content: "";
    background-image: url("../../assets/tariffs/check.png");
    background-size: contain;
    width: 12px;
    height: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: none;
}

.custom-checkbox input[type="checkbox"]:checked + label::after {
    display: block;
}

.selected-numbers-viber {
    border-bottom: 1px solid lightgrey;
    margin-bottom: 40px;
}

.input-img {
    width: 26px;
}

.input-button {
    width: 44px;
    height: 44px;
    background-color: #7a70df;
    margin-left: -47px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.viber {
    color: #7a70df;
}

.telegram {
    color: #27a6e5;
}

.month-discount {
    font-family: Gilroy;
}

.number-count {
    color: #7a70df;
    font-size: 21px;
    font-family: "Gilroy";
    font-weight: 600;
}

.month-count {
    background-color: white;
    padding: 5px 10px;
    border-radius: 5px;
    margin-right: 10px;
}

.month-item {
    background-color: var(--block-color);
    min-width: 270px;
    padding: 7px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    font-family: Gilroy;
    border: 1px solid transparent;
    font-weight: 500;
}

.selected {
    padding: 1px;
    border-radius: 8px;
    background: linear-gradient(to bottom, #27a6e5 0%, #7a70df 100%);
}

.is-loading {
    height: 140px;

    * {
        display: none;
    }

    &:after {
        display: inline-block;
        content: "Loading...";
        content: attr(data-loading-msg);
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
        position: relative;

        font-size: 24px;
        font-family: "Gilroy";
        font-weight: 500;

        text-transform: uppercase;

        color: lightgrey;
    }
}

.selected-numbers-container {
    margin-top: 25px;
    padding: 30px 20px;
    border: 1px solid lightgray;
    border-radius: 10px;
    max-width: 1213px;
}

.selected-numbers-main_title {
    font-family: "Gilroy";
    font-size: 24px;
    line-height: 28px;
    font-weight: 500;
    text-transform: uppercase;
    margin-bottom: 40px;
}

.month-count-container {
    margin-bottom: 30px;
    padding-bottom: 50px;
    border-bottom: 1px solid lightgray;
}

.selected-numbers-title {
    font-family: "Gilroy";
    text-transform: uppercase;
    font-size: 24px;
    line-height: 28px;
    font-weight: 500;
}

.title-container {
    margin-bottom: 25px;
}

.selected-numbers-input {
    width: 255px;
    height: 50px;
    border: 1px solid lightgrey;
    color: black;
    padding-left: 10px;
    border-radius: 6px;
}

.input-container {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
}

.arrow-img {
    transition: transform 0.5s ease;
}

.table-title {
    font-family: "Gilroy";
    font-weight: 600;
    line-height: 19px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: baseline;
}

.reverced {
    transform: rotate(180deg);
    transition: transform 0.5s ease;
}

.filter {
    display: flex;
    justify-content: center;
    align-items: baseline;
    gap: 5px;
}
</style>
